// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"610ceeaf","710":"9d429f86"}[chunkId] + ".chunk.js";
};